export default "__VITE_ASSET__02bd8a79__"